<template>
  <!--弹窗-->
    <el-dialog width="840px" :title="title" :visible.sync="visible" :before-close="handleClose" top="10vh">
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item label="关键词：" class="query-form-item">
                <el-input v-model="filter.keyword" placeholder="输入关键词" style="width: 200px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="" class="query-form-item">
                <el-button size="mini" @click="onReset" icon="el-icon-refresh"></el-button>
                <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
                <el-button type="success" size="mini" icon="el-icon-plus" @click="add">添加关键词</el-button>
                <el-button type="success" size="mini" @click="addupload">导入关键词</el-button>
            </el-form-item>
            <el-form-item label="" class="query-form-item" style="float:right;margin-right:6px;">
                <el-button :disabled="multipleSelection.length == 0" @click="deleteKeyword" type="danger" size="mini" icon="el-icon-delete-solid">删除</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            height="500"
            ref="multipleTable"
            stripe border style="width: 100%;min-height: calc(80vh - 178px);"
            @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                width="50"
                align="center">
            </el-table-column>
            <el-table-column
                label="关键词"
                min-width="168"
                align="center">
                <template slot-scope="scope">
                    <span>{{scope.row.keyword}}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="添加日期"
                width="140"
                align="center">
                <template slot-scope="scope">
                    <span>{{scope.row.add_time}}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="操作"
                width="130"
                align="center">
                <template slot-scope="scope">
                    <el-button type="danger" size="small" @click="deleteKeyword(scope.row)" :disabled="buttonLoading">删除</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <el-row style="margin-top:17px; ">
            <el-pagination
                :current-page="query.page"
                background
                :page-size="query.limit"
                style="float: left;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="query.total">
            </el-pagination>
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                plain
                @click="handleClose"
            >取 消</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
export default {
    data() {
        return {
            loading: false,
            buttonLoading: false,
            query: {
                page: 1,
                limit: 20
            },
            list: [],
            data: {},
            multipleSelection: [],
            filter: {}
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        async Keywords(data) {
            this.data = data;
            this.buttonLoading = true;
            let obj = this.query;
            obj.folder_id = data.id;
            obj.filter = this.filter;
            await api
                .kw_folder_keywords(obj)
                .then(res => {
                    this.buttonLoading = false;
                    if (res.code === 0) {
                        this.list = res.data.list;
                        this.query.page = res.data.page;
                        this.query.total = res.data.total;
                        this.query.total_page = res.data.total_page;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.buttonLoading = false;
                });
        },
        //回调
        Keywords_callback() {
            this.onReset();
        },
        // 添加关键词
        add() {
            this.$emit("onaddKeyword", this.data);
        },
        // 添加关键词
        addupload() {
            this.$emit("Upload", this.data);
        },
        //删除关键词
        deleteKeyword() {
            this.$confirm(
                `确定要删除这 ${this.multipleSelection.length} 个关键词吗?`,
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    this.loading = true;
                    api.rm_keywords({
                        ids: this.multipleSelection
                    })
                        .then(res => {
                            this.loading = false;
                            if (res.code === 0) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success"
                                });
                                this.Keywords(this.data);
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {});
        },
        //多选框
        handleSelectionChange(val) {
            let arr = [];
            val.map(v => {
                arr.push(v.id);
            });
            this.multipleSelection = arr;
        },
        //重置
        onReset() {
            this.query = {
                page: 1,
                limit: 20,
                total: 0
            };
            this.filter = {};
            this.Keywords(this.data);
        },
        //查询
        onSubmit() {
            this.query.page = 1;
            this.Keywords(this.data);
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.Keywords(this.data);
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.Keywords(this.data);
        },
        // 关闭弹窗
        handleClose() {
            this.$emit("close-callback", false);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
/deep/ .el-dialog__body {
    padding-top: 0 !important;
}
</style>
